<template>
  <page-content title="Konsultasi Psikologi: Registrasi" back-button>
    <br />
    <c-input
      label="Hal yang akan dikonsultasikan"
      type="textarea"
      v-model="form.problem"
      :error="!isEmpty(errors.problem)"
      :error-message="errors.problem"
    />

    <c-input
      label="Nomor HP (WhatsApp)"
      sub-label="Pastikan sudah benar, saudara akan dihubungi melalui nomor ini"
      type="number"
      v-model="form.phone"
      :error="!isEmpty(errors.phone)"
      :error-message="errors.phone"
    />

    <c-input-radio
      label="Jadwal Konsultasi"
      :error="!isEmpty(errors.scheduleId)"
      :error-message="errors.scheduleId"
    >
      <c-input-radio-item
        v-for="schedule in scheduleOptions"
        :key="schedule.id"
        v-model="form.scheduleId"
        :c-value="schedule.id"
        :text="
          getScheduleOptionText(
            schedule.day,
            schedule.time_start,
            schedule.time_end
          )
        "
        class="d-block"
      />
    </c-input-radio>

    <h3 class="mb-2">Skrining</h3>

    <c-input-radio
      v-for="(screening, index) in screeningQuestions"
      :key="index"
      :label="screening.question"
    >
      <c-input-radio-item
        v-for="option in screening.options"
        :key="option"
        v-model="screening.answer"
        :c-value="option"
        :text="option"
        class="d-block"
      />
      <div v-if="screening.otherOption">
        <c-input-radio-item
          v-model="screening.answer"
          c-value="other"
          text="Lainnya"
        />
        <c-input
          v-if="screening.answer == 'other'"
          v-model="screening.otherAnswer"
          placeholder="Masukkan keterangan lainnya..."
          class="mt-2 mb-0"
        />
      </div>
    </c-input-radio>
    <button-loading
      class="btn btn-block btn-primary"
      :loading="isLoading"
      :loading-color="colorPrimary"
      @click="doSubmit"
    >
      Daftar
    </button-loading>
  </page-content>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import { camelize, decamelize } from "@ridi/object-case-converter";
import { populateFormErrors, resetFormErrors } from "@/helpers/form";
import { getScheduleOptionText } from "@/helpers/mental-health";

export default {
  name: "mental-health-registration",
  data: function () {
    return {
      isLoading: false,
      screeningQuestions: [],
      form: {
        problem: "",
        phone: "",
        scheduleId: "",
      },
      errors: {
        problem: "",
        phone: "",
        scheduleId: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      scheduleOptions: "mentalHealth/schedule/schedules",
    }),
  },
  methods: {
    getScheduleOptionText,
    doSubmit: function () {
      this.isLoading = true;
      resetFormErrors(this.errors);

      const form = {
        ...decamelize(this.form),
        screenings: this.screeningQuestions.map((item) => ({
          question: item.question,
          answer: item.answer == "other" ? item.otherAnswer : item.answer,
        })),
      };

      axios
        .post(this.apiBaseUrl + "mental-health/checkups/register", form)
        .then(() => {
          // Reset form
          resetFormErrors(this.form);

          this.isLoading = false;
          this.$toasted.success("Pendaftaran berhasil.");

          // Go to history
          this.$router.push({ name: "mental-health-history" });
        })
        .catch((error) => {
          this.isLoading = false;
          const response = error.response;
          const code = response.status;

          if (code === 422) {
            populateFormErrors(this.errors, camelize(response.data.message));
            this.$toasted.error("Data belum benar.");
          } else {
            this.$toasted.error("Terjadi kesalahan.");
          }
        });
    },
  },
  created: function () {
    // Initial phone number value
    this.form.phone = this.loggedUser.phone;

    this.$store.dispatch("mentalHealth/schedule/getAll");
    this.$store
      .dispatch("mentalHealth/checkup/getScreeningQuestions")
      .then((response) => {
        const questions = response.data.data;

        // Add answer & otherAnswer property
        this.screeningQuestions = questions.map((q) => {
          return {
            ...q,
            answer: q.default ?? "",
            otherAnswer: "",
          };
        });
      });
  },
};
</script>
